<template>
  <div>
    <modal
      name="user"
      :adaptive="true"
      :minHeight="800"
      :maxHeight="auto"
      :scrollable="true"
    >
      <modal-user-role :data="this.data" />
      <div class="text-center mt-4">
        <h6 class="text-gray-600 text-xl font-bold">User</h6>
      </div>
      <div style="margin: 20px">
        <FormulateForm @submit="updateUser">
          <div class="text-center items-center justify-center">
            <div class="text-white inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-lg">
              <img
                class="shadow-xl rounded-full h-auto align-middle border-none absolute"
                alt="Team"
                :src="this.data.avatar"
                width="85"
                height="85"
              />
            </div>
          </div>
          <div class="flex flex-wrap">
            <div class="w-full xl:w-4/12 mb-4 xl:mb-0 px-2">
              <FormulateInput
                type="text"
                name="first_name"
                :value="this.data.first_name"
                tooltip="EIN is an employee identification number"
                label="First Name"
                outer-class="mb-4"
                input-class="border border-gray-400 rounded px-3 py-2 leading-none focus:border-green-500 outline-none border-box w-full mb-1"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                help-class="text-xs mb-1 text-gray-600"
                error-class="text-red-700 text-xs mb-1"
              />
            </div>
            <div class="w-full xl:w-4/12 mb-4 xl:mb-0 px-2">
              <FormulateInput
                type="text"
                name="middle_name"
                :value="this.data.middle_name"
                tooltip="EIN is an employee identification number"
                label="Middle Name"
                outer-class="mb-4"
                input-class="border border-gray-400 rounded px-3 py-2 leading-none focus:border-green-500 outline-none border-box w-full mb-1"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                help-class="text-xs mb-1 text-gray-600"
                error-class="text-red-700 text-xs mb-1"
              />
            </div>
            <div class="w-full xl:w-4/12 mb-4 xl:mb-0 px-2">
              <FormulateInput
                type="text"
                name="last_name"
                :value="this.data.last_name"
                tooltip="EIN is an employee identification number"
                label="Last Name"
                outer-class="mb-4"
                input-class="border border-gray-400 rounded px-3 py-2 leading-none focus:border-green-500 outline-none border-box w-full mb-1"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                help-class="text-xs mb-1 text-gray-600"
                error-class="text-red-700 text-xs mb-1"
              />
            </div>
            <div class="w-full xl:w-4/12 mb-4 xl:mb-0 px-2">
              <FormulateInput
                type="email"
                name="email"
                label="Email"
                :value="this.data.email"
                outer-class="mb-4"
                input-class="border border-gray-400 rounded px-3 py-2 leading-none focus:border-green-500 outline-none border-box w-full mb-1"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                help-class="text-xs mb-1 text-gray-600"
                error-class="text-red-700 text-xs mb-1"
              />
            </div>
            <div class="w-full xl:w-4/12 mb-4 xl:mb-0 px-2">
              <FormulateInput
                type="text"
                name="city"
                label="City"
                :value="this.data.city"
                outer-class="mb-4"
                :placeholder="Description"
                input-class="border border-gray-400 rounded px-3 py-2 leading-none focus:border-green-500 outline-none border-box w-full mb-1"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                help-class="text-xs mb-1 text-gray-600"
                error-class="text-red-700 text-xs mb-1"
              />
            </div>
            <div class="w-full xl:w-4/12 mb-4 xl:mb-0 px-2">
              <FormulateInput
                type="text"
                name="country"
                label="Country"
                :value="this.data.country"
                outer-class="mb-4"
                input-class="border border-gray-400 rounded px-3 py-2 leading-none focus:border-green-500 outline-none border-box w-full mb-1"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                help-class="text-xs mb-1 text-gray-600"
                error-class="text-red-700 text-xs mb-1"
              />
            </div>
            <div class="w-full xl:w-6/12 mb-4 xl:mb-0 px-2">
              <FormulateInput
                type="text"
                name="created_at"
                label="Created"
                readonly="true"
                v-model="this.data.created_at"
                outer-class="mb-4"
                input-class="border border-gray-400 bg-gray-300 rounded px-3 py-2 leading-none focus:border-green-500 outline-none border-box w-full mb-1"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                help-class="text-xs mb-1 text-gray-600"
                error-class="text-red-700 text-xs mb-1"
              />
            </div>
            <div class="w-full xl:w-6/12 mb-4 xl:mb-0 px-2">
              <FormulateInput
                type="text"
                name="updated_at"
                label="Updated"
                readonly="true"
                v-model="this.data.updated_at"
                outer-class="mb-4"
                input-class="border border-gray-400 bg-gray-300 rounded px-3 py-2 leading-none focus:border-green-500 outline-none border-box w-full mb-1"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                help-class="text-xs mb-1 text-gray-600"
                error-class="text-red-700 text-xs mb-1"
              />
            </div>
            <div class="w-full xl:w-12/12 mb-4 xl:mb-0 px-2">
              <FormulateInput
                type="text"
                name="description"
                label="Description"
                :value="this.data.description"
                outer-class="mb-4"
                input-class="border border-gray-400 rounded px-3 py-2 leading-none focus:border-green-500 outline-none border-box w-full mb-1"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                help-class="text-xs mb-1 text-gray-600"
                error-class="text-red-700 text-xs mb-1"
              />
            </div>
            <div
              v-if="this.currentUser.token = this.data.token"
              class="w-full xl:w-6/12 xl:mb-0 px-2"
            >
              <FormulateInput
                input-class="px-4 py-2 w-full rounded bg-blue-500 text-white hover:bg-blue-700"
                type="submit"
                name="Update"
              />
            </div>
            <div
              v-if="this.currentUser.token == this.data.token"
              class="w-full xl:w-6/12 xl:mb-0 px-2"
              @click="deleteUser"
            >
              <FormulateInput
                input-class="px-4 py-2 w-full rounded bg-blue-500 text-white hover:bg-blue-700"
                type="submit"
                name="Delete"
              />
            </div>
          </div>
        </FormulateForm>
        <div class="flex-auto mt-6">
          <div class="relative mt-6">
            <vue-good-table
              max-height="200px"
              :columns="columns"
              :rows="this.data.roles"
              :lineNumbers="true"
              :search-options="{
                enabled: true,
                placeholder: 'Search Role'
              }"
            >
              <div slot="table-actions">
                <button
                  @click="showModalAddRole"
                  class="bg-blue-600 text-white active:bg-pink-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 mb-1"
                >
                  <i class="fas fa-plus"></i>
                  Add Role
                </button>
              </div>
            </vue-good-table>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
/* 
  Class: ModalUser
  Description: This class representing a user modal.
*/

/* Imports */
import ModalUserRole from "@/components/Modals/Users/ModalUserRole.vue";
import UserService from "@/services/user.service";
/* /Imports/ */

export default {
  /* 
    Define data with custom users state values. 
  */
  data() {
    return {
      dataRoles: null,
      columns: [
        {
          label: "Name",
          field: "name",
        },
        {
          label: "Description",
          field: "description",
        },
      ],
      rows: this.dataRoles,
    };
  },

  /* 
    Define different components for reusability. 
  */
  components: {
    ModalUserRole,
  },

  /* 
    Define props from which we got user data. 
  */
  props: {
    data: null,
  },

  /* 
    Define computed properties to obtain different getters and setters and save them into the instance. 
  */
  computed: {
    /* 
      Obtain current user object from the store. 
    */
    currentUser() {
      return this.$store.state.auth.user;
    },
  },

  /* 
    Define methods for separate different logic. 
  */
  methods: {
    /* 
      Show modal for assign new role to the users. 
    */
    showModalAddRole() {
      this.$modal.show("user_role");
    },
    
    /* 
      Call UserService class to update certain data on user.
    */
    updateUser(data) {
      if (confirm("Are you sure you want to change the data?")) {
        if (data.email == this.data.email) delete data["email"];
        UserService.updateUser(this.data.id, data).then(() => {
          location.reload();
        });
      }
    },

     /* 
      Call UserService class to delete certain user.
    */
    deleteUser() {
      if (confirm("Are you sure you want to delete the data?")) {
        UserService.deleteUser(this.data.id).then(() => {
          location.reload();
        });
      }
    },
  },
  
  /* 
    Check if user is authenticated.
  */
  mounted() {
    if (!this.currentUser) {
      this.$router.push("/login");
    }
  }
};
</script>
